"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRoomSession = exports.isVideoController = exports.isOnSiteRoomSession = exports.isHostRoomSession = exports.isSpectatorRoomSession = void 0;
const spectator_room_session_1 = require("../data/session/spectator_room_session");
const host_room_session_1 = require("../data/session/host_room_session");
const room_session_1 = require("../data/session/room_session");
const onsite_room_session_1 = require("../data/session/onsite_room_session");
const video_controllers_1 = require("../data/controllers/video_controller/video_controllers");
function isSpectatorRoomSession(session) {
    return session instanceof spectator_room_session_1.SpectatorRoomSession;
}
exports.isSpectatorRoomSession = isSpectatorRoomSession;
function isHostRoomSession(session) {
    return session instanceof host_room_session_1.HostRoomSession;
}
exports.isHostRoomSession = isHostRoomSession;
function isOnSiteRoomSession(session) {
    return session instanceof onsite_room_session_1.OnSiteRoomSession;
}
exports.isOnSiteRoomSession = isOnSiteRoomSession;
function isVideoController(controller) {
    return controller instanceof video_controllers_1.VideoController;
}
exports.isVideoController = isVideoController;
function isRoomSession(session) {
    return session instanceof room_session_1.RoomSession;
}
exports.isRoomSession = isRoomSession;
//# sourceMappingURL=guards.js.map